<script>
import { VMoney, Money } from 'v-money'
import utils from '@/utils/utils'

export default {
  name: 'AppDoubleInput',
  components: {
    Money
  },
  props: {
    disable: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      required: true,
      default: 0
    },
    masked: {
      type: Boolean,
      default: false
    },
    precision: {
      type: Number,
      default: () => 2
    },
    decimal: {
      type: String,
      default: () => ','
    },
    thousands: {
      type: String,
      default: () => '.'
    },
    prefix: {
      type: String,
      default: () => ''
    },
    suffix: {
      type: String,
      default: () => ''
    },
    showAppend: {
      type: Boolean,
      default: false
    },
    hasValidationError: {
      type: Boolean,
      default: false
    },
    hasLimitValue: {
      type: Number,
      required: false
    },
    appendText: {
      type: String,
      required: false,
      default: 'hectare(s)'
    },
    maxlength: {
      type: Number,
      default: () => 12
    },
    propId: {
      type: String,
      required: false
    }
  },
  directives: { money: VMoney },
  data () {
    return {
      formattedValue: '',
      money: {
        decimal: this.decimal,
        thousands: this.thousands,
        prefix: this.prefix,
        suffix: this.suffix,
        precision: this.precision,
        masked: false,
        maxlength: this.maxlength
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        const formatted = utils.format(newValue, this.$props)
        if (formatted !== this.formattedValue) {
          if (this.$refs.maskedInput) {
            this.$refs.maskedInput.$refs.input.value = formatted
          }
          this.formattedValue = formatted
        }
      }
    }
  },
  methods: {
    change (evt) {
      this.$emit('change')
      const value = this.masked ? evt.target.value : utils.unformat(evt.target.value, this.precision)
      if (this.value !== value) {
        this.$emit('areaString', evt.target.value)
        this.$emit('input', this.masked ? evt.target.value : utils.unformat(evt.target.value, this.precision))
      }
    }
  }
}
</script>

<template>
  <div class="el-input-group el-input-group--prepend">
    <money
      :maxlength="hasLimitValue ? hasLimitValue : 12"
      v-model="formattedValue"
      :disabled="disable"
      v-bind="money"
      class="el-input__inner"
      @change.native="change"
      :class="{
        desabilitado: disable,
        'input erro': hasValidationError
      }"
      :id="propId ? `${propId}-input` : 'input-default-id'"
    />
    <span v-if="showAppend" class="el-input-group__append">{{ appendText }}</span>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/element-variables.scss";

.el-input__inner {
  border-radius: 4px;
  font-size: 14px;
}

.el-input-group__append {
  color: $--color-text-regular
}

.desabilitado {
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #C0C4CC;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/InputDouble/InputDouble.vue